import React from 'react';
import Button from './Button'
import './HomeSection.css'


const HomeSection = ({
    lightBg, topLine, lightText, lightTextDesc, headLine, description, buttonLabel, img, alt, imgStart, hideButton, grantImage
}) => {

    return(
        <div className={lightBg ? 'home__home-section' : 'home__home-section darkBg'}>
            <div className="container">
                <div 
                className="row home__home-row"
                style={{display: 'flex', flexDirection: imgStart ? 'row-reverse' : 'row'}}>
                    <div className="col">
                        <div className="home__home-text-wraper">
                            <div className="top-line">{topLine}</div>
                            <h1 className={lightText ? 'heading' : 'heading dark'}>{headLine}</h1>
                            <p className={lightTextDesc ? 'home__home-subtitle' : 'home__home-subtitle dark'}>{description}</p>
                            {grantImage ? (
                                <a className="grant-image-link" href="https://elevenlabs.io/startup-grants" target="_blank" rel="noopener noreferrer">
                                    <img className="grant-image" src="https://eleven-public-cdn.elevenlabs.io/payloadcms/pwsc4vchsqt-ElevenLabsGrants.webp" alt="ElevenLabs startup grants" />
                                </a>
                            ) : null}
                            {!hideButton ? 
                            
                                <a href='https://share-eu1.hsforms.com/1F7v0zpdWSQq9w8lsSlAFMg2dfb6a'><Button buttonSize='btn--wide' buttonColor='blue' >{buttonLabel}</Button></a>
                               : ""
                            }

                        </div>
                    </div>
                    <div className="col">
                        <div className="home__home-img-wrapper">
                            <img className="home__home-img" src={img} alt={alt}/> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeSection;
